export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  // {
  //   title: 'Post',
  //   faIcon: 'fas fa-envelope',
  //   // hideActive: true,
  //   // userCheck: { type: 'digitalEnabled', value: false },
  //   route: {
  //     name: 'post-search',
  //     // query: { postType: 'Physical' },
  //   },
  // },
  {
    title: 'Keywords',
    route: 'keyword-search',
    icon: 'SearchIcon',
  },
  {
    title: 'Bans',
    faIcon: 'fas fa-ban',
    children: [
      {
        title: 'External User Bans',
        route: 'bans',
      },
      {
        title: 'Prisoner Bans',
        route: 'digital-mail-restrictions',
      },
    ],
  },
  {
    title: 'Site Locations',
    route: 'locations',
    faIcon: 'fas fa-warehouse',
  },
  {
    title: 'Mail Monitors',
    route: 'mail-monitors',
    faIcon: 'fas fa-envelope',
  },
  {
    title: 'Post Replies',
    faIcon: 'fas fa-reply',
    userCheck: [
      { type: 'repliesEnabled', value: true },
      { type: 'physicalEnabled', value: true },
    ],
    route: {
      name: 'post-reply-search',
    },
  },
  {
    title: 'Reply Failures',
    faIcon: 'fas fa-exclamation-triangle',
    userCheck: [
      { type: 'repliesEnabled', value: true },
      { type: 'physicalEnabled', value: true },
    ],
    route: {
      name: 'post-replies-fail',
    },
  },
]
